import { useEventsContext } from '../../../context/events/EventsContext';
import { useRestoreClipMutation } from '../operation.generated';
import { EventName } from '../../../services/EventTrackingService';

const useRestoreClip = (
  options: Parameters<typeof useRestoreClipMutation>[0] = {}
) => {
  const [eventTracking] = useEventsContext();
  return useRestoreClipMutation({
    ...options,
    onCompleted: data => {
      if (data.restoreClip.success && data.restoreClip.clip) {
        eventTracking.track({
          type: EventName.ClipRestored,
          data: { clipId: data.restoreClip.clip.id },
        });
      }
    },
  });
};

export default useRestoreClip;
